import { render, staticRenderFns } from "./VolunteerScoresDialog.vue?vue&type=template&id=2c83026c&scoped=true"
import script from "./VolunteerScoresDialog.vue?vue&type=script&lang=js"
export * from "./VolunteerScoresDialog.vue?vue&type=script&lang=js"
import style0 from "./VolunteerScoresDialog.vue?vue&type=style&index=0&id=2c83026c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83026c",
  null
  
)

export default component.exports